module.exports = __webpack_public_path__ + "mq.850bc87fec4b3e58ed96.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/mq.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/mq.svg
// module chunks = styles